"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  addFonts: () => addFonts,
  css: () => classNames,
  deleteColor: () => deleteColor,
  dimColor: () => dimColor,
  errorColor: () => errorColor,
  facebookColor: () => facebookColor,
  fontFamily: () => fontFamily,
  fontSize: () => fontSize,
  gifOverlayColor: () => gifOverlayColor,
  giphyAqua: () => giphyAqua,
  giphyBlack: () => giphyBlack,
  giphyBlue: () => giphyBlue,
  giphyCharcoal: () => giphyCharcoal,
  giphyDarkCharcoal: () => giphyDarkCharcoal,
  giphyDarkGrey: () => giphyDarkGrey,
  giphyDarkestGrey: () => giphyDarkestGrey,
  giphyGreen: () => giphyGreen,
  giphyIndigo: () => giphyIndigo,
  giphyLightBlue: () => giphyLightBlue,
  giphyLightCharcoal: () => giphyLightCharcoal,
  giphyLightGrey: () => giphyLightGrey,
  giphyLightestGrey: () => giphyLightestGrey,
  giphyPink: () => giphyPink,
  giphyPurple: () => giphyPurple,
  giphyRed: () => giphyRed,
  giphyWhite: () => giphyWhite,
  giphyWhiteSmoke: () => giphyWhiteSmoke,
  giphyYellow: () => giphyYellow,
  instagramColor: () => instagramColor,
  loader: () => loader_default,
  pinterestColor: () => pinterestColor,
  primaryCTA: () => primaryCTA,
  primaryCTADisabled: () => primaryCTADisabled,
  redditColor: () => redditColor,
  secondaryCTA: () => secondaryCTA,
  smsColor: () => smsColor,
  tumblrColor: () => tumblrColor,
  twitterColor: () => twitterColor
});
module.exports = __toCommonJS(src_exports);

// src/colors.ts
var giphyBlack = "#121212";
var giphyDarkestGrey = "#212121";
var giphyDarkGrey = "#2e2e2e";
var giphyDarkCharcoal = "#3e3e3e";
var giphyCharcoal = "#4a4a4a";
var giphyLightCharcoal = "#5c5c5c";
var giphyLightGrey = "#a6a6a6";
var giphyLightestGrey = "#d8d8d8";
var giphyWhiteSmoke = "#ececec";
var giphyWhite = "#ffffff";
var giphyBlue = "#00ccff";
var giphyGreen = "#00ff99";
var giphyPurple = "#9933ff";
var giphyRed = "#ff6666";
var giphyYellow = "#fff35c";
var giphyAqua = "#00e6cc";
var giphyLightBlue = "#3191ff";
var giphyIndigo = "#6157ff";
var giphyPink = "#e646b6";
var facebookColor = "#3894fc";
var twitterColor = "#00ccff";
var pinterestColor = "#e54cb5";
var tumblrColor = "#529ecc";
var instagramColor = "#c23c8d";
var redditColor = "#fc6669";
var smsColor = "#00ff99";
var errorColor = giphyRed;
var deleteColor = giphyRed;
var primaryCTA = giphyIndigo;
var primaryCTADisabled = "#241F74";
var secondaryCTA = giphyCharcoal;
var dimColor = `rgba(0, 0, 0, 0.8)`;
var gifOverlayColor = `rgba(0, 0, 0, 0.4)`;

// src/loader.ts
var import_emotion = require("emotion");
var bouncer = import_emotion.keyframes`
     to {
    transform: scale(1.75) translateY(-20px);
  }
`;
var loaderHeight = 37;
var loader = import_emotion.css`
    display: flex;
    align-items: center;
    height: ${loaderHeight}px;
    padding-top: 15px;
    margin: 0 auto;
    text-align: center;
    justify-content: center;
    animation: pulse 0.8s ease-in-out 0s infinite alternate backwards;
    div {
        display: inline-block;
        height: 10px;
        width: 10px;
        margin: ${loaderHeight}px 10px 10px 10px;
        position: relative;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);
        animation: ${bouncer} cubic-bezier(0.455, 0.03, 0.515, 0.955) 0.75s infinite alternate;
        &:nth-child(5n + 1) {
            background: ${giphyGreen};
            animation-delay: 0;
        }
        &:nth-child(5n + 2) {
            background: ${giphyBlue};
            animation-delay: calc(0s + (0.1s * 1));
        }
        &:nth-child(5n + 3) {
            background: ${giphyPurple};
            animation-delay: calc(0s + (0.1s * 2));
        }
        &:nth-child(5n + 4) {
            background: ${giphyRed};
            animation-delay: calc(0s + (0.1s * 3));
        }
        &:nth-child(5n + 5) {
            background: ${giphyYellow};
            animation-delay: calc(0s + (0.1s * 4));
        }
    }
`;
var loader_default = loader;

// src/typography.ts
var import_emotion2 = require("emotion");
var addFonts = () => import_emotion2.injectGlobal`
@font-face {
    font-family: 'interface';
    font-style: normal;
    font-weight: normal;
    src: url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/InterFace_W_Rg.woff2') format('woff2'),
        url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/InterFace_W_Rg.woff') format('woff');
}

@font-face {
    font-family: 'interface';
    font-style: normal;
    font-weight: bold;
    src: url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/InterFace_W_Bd.woff2') format('woff2'),
        url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/InterFace_W_Bd.woff') format('woff');
}
@font-face {
    font-family: 'interface';
    font-style: normal;
    font-weight: 900;
    src: url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/InterFace_W_XBd.woff') format('woff');
}
@font-face {
    font-family: 'nexablack'; 
    font-style: normal;
    font-weight: normal;
    src: url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/nexa_black-webfont.woff2') format('woff2'),
        url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/nexa_black-webfont.woff') format('woff');
}
@font-face {
    font-family: 'SSStandard'; 
    font-style: normal;
    font-weight: normal;
    src:  url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/ss-standard.woff') format('woff');
}
@font-face {
    font-family: 'SSSocial'; 
    font-style: normal;
    font-weight: normal;
    src:  url('https://s3.amazonaws.com/giphyscripts/react-giphy-brand/fonts/ss-social.woff') format('woff');
}
`;
try {
  if (!process.env.GIPHY_SDK_NO_FONTS) {
    addFonts();
  }
} catch (error) {
  addFonts();
}
var fontFamily = {
  title: "'nexablack', sans-serif",
  body: "interface, Helvetica Neue, helvetica, sans-serif;"
};
var fontSize = {
  titleSmall: "20px",
  title: "26px",
  titleLarge: "36px",
  subheader: "16px",
  subheaderSmall: "12px"
};
var sharedTitle = import_emotion2.css`
    font-family: ${fontFamily.title};
    -webkit-font-smoothing: antialiased;
`;
var title = (0, import_emotion2.cx)(
  import_emotion2.css`
        font-size: ${fontSize.title};
    `,
  sharedTitle
);
var titleLarge = (0, import_emotion2.cx)(
  import_emotion2.css`
        font-size: ${fontSize.titleLarge};
    `,
  sharedTitle
);
var titleSmall = (0, import_emotion2.cx)(
  import_emotion2.css`
        font-size: ${fontSize.titleSmall};
    `,
  sharedTitle
);
var sharedSubheader = import_emotion2.css`
    font-family: ${fontFamily.body};
    font-weight: bold;
    -webkit-font-smoothing: antialiased;
`;
var subheader = (0, import_emotion2.cx)(
  import_emotion2.css`
        font-size: ${fontSize.subheader};
    `,
  sharedSubheader
);
var subheaderSmall = (0, import_emotion2.cx)(
  import_emotion2.css`
        font-size: ${fontSize.subheaderSmall};
    `,
  sharedSubheader
);
var sectionHeader = import_emotion2.css`
    font-family: ${fontFamily.body};
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    -webkit-font-smoothing: antialiased;
`;
var classNames = {
  sectionHeader,
  subheaderSmall,
  subheader,
  titleLarge,
  titleSmall,
  title
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  addFonts,
  css,
  deleteColor,
  dimColor,
  errorColor,
  facebookColor,
  fontFamily,
  fontSize,
  gifOverlayColor,
  giphyAqua,
  giphyBlack,
  giphyBlue,
  giphyCharcoal,
  giphyDarkCharcoal,
  giphyDarkGrey,
  giphyDarkestGrey,
  giphyGreen,
  giphyIndigo,
  giphyLightBlue,
  giphyLightCharcoal,
  giphyLightGrey,
  giphyLightestGrey,
  giphyPink,
  giphyPurple,
  giphyRed,
  giphyWhite,
  giphyWhiteSmoke,
  giphyYellow,
  instagramColor,
  loader,
  pinterestColor,
  primaryCTA,
  primaryCTADisabled,
  redditColor,
  secondaryCTA,
  smsColor,
  tumblrColor,
  twitterColor
});
